import { useParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import RuleInfos from "../../components/rules/ruleinfos";



export default function ViewRule() {
    // states
    let coderule = useParams();
    const [page, setPage] = useState(0);



    const displayPages = () => {
        if (page === 0) {
            return <RuleInfos coderule={coderule.code} />;
        }
        // else {
        //     return <NomensDomaine nomtab={nomtab} type={type} />;
        // } 
        // else {
        //     return <EmployeeScans refid={refId} code={codeemploye.code}  />;
        // }
    }


    // comportements
    useEffect(() => {

    }, []);



    // affichages
    return (
        <div className="container-fluid">
            <h1 className="h4 mb-2 font-weight-bold text_primary">Droits</h1>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", justifyItems: "center" }}>
                <button onClick={() => { setPage(0) }} className={`btn-shadow rounded-0 btn ${page === 0 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>Informations du droit</span>
                </button>
                {/* <button onClick={() => {setPage(1)}} className={`btn-shadow rounded-0 btn ${page === 1 ? 'btn-primary' : 'btn-secondary'}`}>
                                    <span>Profils du droit</span>
                                </button>
                                <button onClick={() => {setPage(2)}} className={`btn-shadow rounded-0 btn ${page === 2 ? 'btn-primary' : 'btn-secondary'}`}>
                                    <span>Espaces de travail du droit</span>
                                </button> */}
            </div>
            {displayPages()}
        </div>
    )
}